import React, { memo } from 'react';


const SendMessageIcon: React.FC = ({ color = '#3399DB' }: any) => {
  return (
    <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.428587 22.375L25.7915 11.5L0.428587 0.625L0.416504 9.08333L18.5415 11.5L0.416504 13.9167L0.428587 22.375Z"
        fill={color} />
    </svg>

  )
};

export default memo(SendMessageIcon);

